<template>
  <div>
    <slot :getDataField="getDataField" :getFilteredDataField="getFilteredDataField">
      <div class="single container-max page-content">
        <div class="row position-relative">
          <div class="col-12 col-md-6">
            <slot name="image-carousel"></slot>
          </div>

          <div class="col-12 col-md-6 mt-3 mt-md-0">
            <div>
              <!-- START SINGLEITEM_DETAILS -->
              <h1 class="h2 title mb-4" data-testing="item-name">
                <span>{{ currentVariation | itemName }}</span>
              </h1>

              <p class="single-description" v-if="isShortDescriptionActive && currentVariation.texts.shortDescription !== ''" v-html="currentVariation.texts.shortDescription"></p>

              <div class="mb-5">
                <span class="articlenumber small d-block">
                  <b>{{ $translate("Ceres::Template.singleItemNumber") }} </b>
                  <span>{{ currentVariation.variation.number }}</span>
                </span>
                <span class="articlenumber small d-block" v-if="currentVariation.filter.hasManufacturer">
                  <b> {{ $translate("Ceres::Template.singleItemManufacturer") }} </b>
                  <span> {{ currentVariation.item.manufacturer.externalName }}</span>
                </span>
                <span
                  class="articlenumber small d-block"
                  v-if="currentVariation.unit"
                  :class="{ 'is-single-piece': currentVariation.unit && currentVariation.unit.content === 1 && currentVariation.unit.unitOfMeasurement === 'C62' }"
                >
                  <b> {{ $translate("Ceres::Template.singleItemContent") }}</b>
                  <span>{{ currentVariation.unit.content | numberFormat }} </span>
                  <span>{{ currentVariation.unit.names.name }}</span>
                </span>
                <span v-if="currentVariation.variation.mayShowUnitPrice" class="articlenumber small d-block">
                  <b>{{ $translate("Ceres::Template.singleItemUnitPrice") }}</b>
                  <span class="base-price-value">{{ variationGraduatedPrice.basePrice | specialOffer(currentVariation.prices, "basePrice") }}</span>
                </span>

                <img
                  :src="currentVariation.item.manufacturer.logo"
                  :alt="currentVariation.item.manufacturer.externalName"
                  class="img-fluid d-block mt-3 manufacturerlogo"
                  v-if="currentVariation.item.manufacturer.logo"
                />
              </div>

              <!-- Variation -->
              <div class="mb-3" v-if="attributes.length || Object.keys(units).length">
                <variation-select></variation-select>
              </div>
              <!-- /Variation -->
              <!-- Item Bundle -->
              <item-bundle
                v-if="currentVariation.variation.bundleType === 'bundle'"
                :bundle-type="currentVariation.variation.bundleType"
                :bundle-components="currentVariation.bundleComponents"
              ></item-bundle>
              <!-- /Item Bundle -->

              <slot name="before-price"></slot>

              <div v-if="currentVariation.filter.isSalable && variationGroupedProperties.length">
                <order-property-list></order-property-list>
              </div>

              <graduated-prices></graduated-prices>

              <item-price :show-cross-price="isRecommendedPriceActive"></item-price>

              <slot name="after-price"></slot>

              <item-availability></item-availability>

              <div class="biozid-danger alert alert-danger mt-3" v-if="biozidDanger">
                {{ $translate("MGCRedesign::Biozid.warningSingle") }}
              </div>

              <div class="mb-3 singleadd">
                <div class="w-100">
                  <slot name="before-add-to-basket"></slot>
                </div>

                <div v-if="currentVariation.item.itemType === 'set'" class="alert alert-info w-100">
                  {{ $translate("Ceres::Template.singleItemSetInfo") }}
                </div>
                <div v-else class="col-12 col-sm-7 col-md-12 col-lg-8 my-3">
                  <add-to-basket
                    :variation-id="currentVariation.variation.id"
                    :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                    :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                    :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                    :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                    :maximum-quantity="
                      !!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null
                    "
                    :order-properties="
                      currentVariation.properties.filter(function(prop) {
                        return prop.property.isOderProperty;
                      })
                    "
                    :has-order-properties="currentVariation.hasOrderProperties"
                    :has-required-order-property="currentVariation.hasRequiredOrderProperty"
                    :use-large-scale="false"
                    :show-quantity="true"
                    :item-url="currentVariation | itemURL"
                    :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                    :has-price="currentVariation | hasItemDefaultPrice"
                  >
                  </add-to-basket>
                </div>

                <div class="w-100 ppbutton" v-if="!biozidDanger">
                  <slot name="after-add-to-basket"></slot>
                </div>
              </div>

              <div v-if="isWishListEnabled" class="row">
                <div class="col-12 wishlist mb-5">
                  <add-to-wish-list :variation-id="currentVariation.variation.id"></add-to-wish-list>
                </div>
              </div>
              <!-- ./ITEM DETAIL -->

              <slot name="additional-content-after-add-to-basket"></slot>

              <slot name="additional-content-after-vat"></slot>
              <!-- END SINGLEITEM_DETAILS -->

              <div class="download-wrapper d-flex">
                <template v-for="property in currentVariation.variationProperties" v-if="currentVariation.variationProperties">
                  <template v-for="(property, index) in property.properties" v-if="property.id == 16 || property.id == 25">
                    <a :href="property.values.value | propertyFileUrl" target="_blank" class="d-block mr-3 mt-3">
                      <img src="https://cdn02.plentymarkets.com/gw81lpaq889b/frontend/webshop/images/static/icons/2021/pdficon.svg" :alt="property.names.name" class="img-fluid d-block mx-auto mb-2" />
                      <span class="color-dark small font-weight-bold">{{ property.names.name }}</span>
                    </a>
                  </template>
                </template>
              </div>

              <div class="properties-wrapper d-flex">
                <template v-for="property in currentVariation.variationProperties" v-if="currentVariation.variationProperties">
                  <template v-for="(property, index) in property.properties" v-if="property.id == 26">
                    <div class="d-block mr-3 mt-3">
                      <span class="color-dark small font-weight-bold">{{ property.values.value }}</span>
                      <img :src="property.description" :alt="property.values.value" class="img-fluid d-block mx-auto mb-2" />
                    </div>
                  </template>
                </template>
              </div>
            </div>
          </div>

          <div class="col-12">
            <!-- ITEM DESCRIPTION -->
            <div class="my-5">
              <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item" v-if="isDescriptionTabActive">
                  <a class="nav-link active" data-toggle="tab" :href="'#details-' + currentVariation.variation.id" role="tab">{{ $translate("Ceres::Template.singleItemDescription") }}</a>
                </li>
                <li class="nav-item" v-if="isTechnicalDataTabActive">
                  <a :class="{ active: !isDescriptionTabActive && isTechnicalDataTabActive }" class="nav-link" data-toggle="tab" :href="'#data-' + currentVariation.variation.id" role="tab">{{
                    $translate("Ceres::Template.singleItemTechnicalData")
                  }}</a>
                </li>

                <li class="nav-item" v-if="isEuResponsibleTabShown">
                  <a class="nav-link" data-toggle="tab" href="#eu-responsible" role="tab">{{ $translate("Ceres::Template.singleItemEuResponsiblePerson") }}</a>
                </li>

                <slot name="add-detail-tabs"></slot>
              </ul>

              <div class="tab-content overflow-hidden">
                <div class="tab-pane active overflow-auto" :id="'details-' + currentVariation.variation.id" role="tabpanel" v-if="isDescriptionTabActive">
                  <div class="my-4" v-html="currentVariation.texts.description"></div>
                </div>
                <div
                  :class="{ active: !isDescriptionTabActive && isTechnicalDataTabActive }"
                  class="tab-pane overflow-auto"
                  :id="'data-' + currentVariation.variation.id"
                  role="tabpanel"
                  v-if="isTechnicalDataTabActive"
                >
                  <div class="my-4" v-html="currentVariation.texts.technicalData"></div>
                </div>

                <div class="tab-pane overflow-auto" id="eu-responsible" role="tabpanel" v-if="isEuResponsibleTabShown">
                  <div class="my-4">
                    <div class="manufacturer mb-3" v-if="currentVariation.filter.hasManufacturer">
                      <p class="font-weight-bold mb-0">{{ $translate("MGCRedesign::Single.ManufacturerHeadline") }}</p>

                      <div class="p-0" v-if="currentVariation.item.manufacturer.name">
                        <span>{{ currentVariation.item.manufacturer.name }}</span>
                      </div>
                      <div class="p-0" v-if="currentVariation.item.manufacturer.street">
                        <span>{{ currentVariation.item.manufacturer.street }} {{ currentVariation.item.manufacturer.houseNo }}</span>
                      </div>
                      <div class="p-0" v-if="currentVariation.item.manufacturer.postcode">
                        <span>{{ currentVariation.item.manufacturer.postcode }} {{ currentVariation.item.manufacturer.town }}</span>
                      </div>
                      <div class="p-0" v-if="currentVariation.item.manufacturer.countryObject">
                        <span>{{ currentVariation.item.manufacturer.countryObject.name }}</span>
                      </div>

                      <div class="p-0" v-if="currentVariation.item.manufacturer.url">
                        <a :href="currentVariation.item.manufacturer.url" target="_blank">{{ currentVariation.item.manufacturer.url }}</a>
                      </div>
                    </div>

                    <p class="font-weight-bold mb-0">{{ $translate("MGCRedesign::Single.EUHeadline") }}</p>
                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.responsibleName }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.responsibleStreet }} {{ currentVariation.item.manufacturer.responsibleHouseNo }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.responsiblePostCode }} {{ currentVariation.item.manufacturer.responsibleTown }}</span>
                    </div>
                    <div class="p-0">
                      <span v-if="currentVariation.item.manufacturer.responsibleCountryObject">
                        {{ currentVariation.item.manufacturer.responsibleCountryObject.name }}
                      </span>
                    </div>

                    <div class="p-0">
                      <a :href="'mailto:' + currentVariation.item.manufacturer.responsibleEmail">
                        {{ currentVariation.item.manufacturer.responsibleEmail }}
                      </a>
                    </div>

                    <div class="p-0">
                      <span>Tel: </span><a :href="'tel:' + currentVariation.item.manufacturer.responsiblePhoneNo">{{ currentVariation.item.manufacturer.responsiblePhoneNo }}</a>
                    </div>
                  </div>
                </div>

                <slot name="add-detail-tabs-content"></slot>
              </div>
            </div>
            <!-- ./ITEM DESCRIPTION -->
          </div>

          <template v-if="currentVariation.item.manufacturer.id == 604 || currentVariation.item.manufacturer.id == 6 || currentVariation.item.manufacturer.id == 4127">
            <div class="col-12 bee my-5">
              <div class="loadbeeTabContent" data-loadbee-apikey="C75UvVXJx5gG39mdbFWmarvwXEVxww4X" :data-loadbee-gtin="currentVariation.barcodes[0].code" data-loadbee-locale="de_DE"></div>
              <script2 async src="https://cdn.loadbee.com/js/loadbee_integration.js"></script2>
            </div>
          </template>
        </div>

        <div class="mb-5">
          <slot name="item-list-container"></slot>
        </div>
        <slot name="feedback-container"></slot>
      </div>
    </slot>
  </div>
</template>

<script>
import { get } from "../../helper/get";
import { isNullOrUndefined } from "../../helper/utils";

export default {
  name: "single-item",

  props: {
    pleaseSelectOptionVariationId: {
      type: Number,
      default: 0,
    },
    initPleaseSelectOption: {
      type: Boolean,
      default: false,
    },
    showNetPrices: {
      type: Boolean,
      default: false,
    },
    isWishListEnabled: {
      type: Boolean,
      default: false,
    },
    itemId: {
      type: Number,
      required: true,
    },
    afterKey: Object,
  },

  jsonDataFields: ["itemData", "attributesData", "variations"],

  provide() {
    return {
      itemId: this.$props.itemId,
    };
  },

  computed: {
    itemConfig() {
      return App.config.item.itemData;
    },
    biozidDanger() {
      return (
        this.currentVariation.variationProperties &&
        Array.isArray(this.currentVariation.variationProperties) &&
        this.currentVariation.variationProperties.some((property) => property.properties && Array.isArray(property.properties) && property.properties.some((prop) => prop.id == 90))
      );
    },
    variationGraduatedPrice() {
      return this.$store.getters[`${this.itemId}/variationGraduatedPrice`];
    },

    isDescriptionTabActive() {
      return (App.config.item.itemData.includes("item.description") || App.config.item.itemData.includes("all")) && !!this.currentVariation.texts.description.length;
    },
    isEuResponsibleTabShown() {
      return (
        this.currentVariation.item.manufacturer.responsibleEmail !== "" ||
        this.currentVariation.item.manufacturer.responsibleHouseNo !== "" ||
        this.currentVariation.item.manufacturer.responsibleName !== "" ||
        this.currentVariation.item.manufacturer.responsiblePhoneNo !== "" ||
        this.currentVariation.item.manufacturer.responsiblePostCode !== "" ||
        this.currentVariation.item.manufacturer.responsibleStreet !== "" ||
        this.currentVariation.item.manufacturer.responsibleTown !== "" ||
        this.currentVariation.item.manufacturer.responsibleCountry !== 0
      );
    },
    isRecommendedPriceActive() {
      return App.config.item.itemData.includes("item.recommendedPrice") || App.config.item.itemData.includes("all");
    },

    isShortDescriptionActive() {
      return App.config.item.itemData.includes("item.shortDescription") || App.config.item.itemData.includes("all");
    },

    hasShippingCostsCategoryId() {
      return App.config.global.shippingCostsCategoryId > 0;
    },

    isTechnicalDataTabActive() {
      return (App.config.item.itemData.includes("item.technical_data") || App.config.item.itemData.includes("all")) && !!this.currentVariation.texts.technicalData.length;
    },

    variationGroupedProperties() {
      return this.$store.getters[`${this.itemId}/variationGroupedProperties`];
    },

    variationMissingProperties() {
      return this.$store.getters[`${this.itemId}/variationMissingProperties`];
    },

    currentVariation() {
      return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
    },

    isVariationSelected() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.isVariationSelected`);
    },

    attributes() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.attributes`);
    },

    units() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.units`);
    },

    isItemSet() {
      return this.$store.state.items.isItemSet;
    },
  },

  created() {
    this.$store.dispatch("initVariation", this.itemData);
    this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, this.pleaseSelectOptionVariationId);
    this.$store.dispatch("addLastSeenItem", this.currentVariation.variation.id);

    this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
      itemId: this.itemId,
      attributes: this.attributesData,
      variations: this.variations,
      initialVariationId: this.currentVariation.variation.id,
      isPleaseSelectOption: this.initPleaseSelectOption,
      afterKey: this.afterKey,
    });
  },

  mounted() {
    this.$nextTick(() => {
      this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
        itemId: this.itemId,
        attributes: this.attributesData,
        variations: this.variations,
        initialVariationId: this.currentVariation.variation.id,
        isPleaseSelectOption: this.initPleaseSelectOption,
        afterKey: this.afterKey,
      });

      if (this.isItemSet) {
        this.$store.dispatch("initSetComponents", this.itemData);
      }
    });

    // listen for variation change to hydrate all children lazy-hydrate components
    document.addEventListener("onVariationChanged", () => this.hydrateChildren(this.$children));
  },

  methods: {
    getDataField(field) {
      return get(this.currentVariation, field);
    },

    getFilteredDataField(field, filter) {
      if (!isNullOrUndefined(this.$options.filters[filter])) {
        return this.$options.filters[filter](this.getDataField(field));
      }

      return this.getDataField(field);
    },

    // iterate recursively the children components and call their hydrate method, if it is a lazy-hydrate component
    hydrateChildren(nodes) {
      nodes.forEach((component) => {
        if (component.$options.name === "lazy-hydrate") {
          component.hydrate();
        } else if (component.$children.length) {
          this.hydrateChildren(component.$children);
        }
      });
    },
  },
};
</script>